import _ from 'underscore';
import Api from '@/lib/api/api';
import v5_Collection from '@/collections/v5/collection';
import Invoice from '@/models/v5/invoice';

var InvoicesCollection = new v5_Collection();
_.extend(InvoicesCollection, {
    model: Invoice,
    url: function () {
        return Api.urls.invoices();
    },
    type: 'invoice',
});
export default InvoicesCollection;
